import { render, staticRenderFns } from "./RsaGestioneCamereStoricoListComponent.vue?vue&type=template&id=49996809"
import script from "./RsaGestioneCamereStoricoListComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneCamereStoricoListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports